import { addFilter } from '@wordpress/hooks'
import { useSelect, dispatch } from '@wordpress/data'
import { PanelRow, TextControl, ToggleControl } from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import Select from 'react-select'

/**
 * Adding Paypal Express Content
 */
addFilter( 'wp_travel_payment_gateway_fields_express_checkout', 'wp-travel', (content) => {
    return [ ...content, <PaypalExpressContent /> ]
});

const PaypalExpressContent = () => {

    /**
     * Get Store Settings.
     */
    const { updateSettings } = dispatch('WPTravel/Admin');

    const allData = useSelect( (select) => {
        return select('WPTravel/Admin').getAllStore()
    }, [] );

    const {
        payment_option_express_checkout,
        wp_travel_express_checkout_production,
        wp_travel_express_checkout_sand_box,
        wp_travel_express_checkout,
        wt_test_mode
    } = allData

    const updatePaypalExpressData = (storeName, storeKey, value) => { // storeName[storeKey] = value
        updateSettings({ ...allData, [storeName]: { ...allData[storeName], [storeKey]: value } })
    }

    const clientIdDesc = __('Get API credentials from <a href="https://developer.paypal.com/developer/applications/" target="__blank">here</a>', 'wp-travel-pro');

    const colorOptions = [
        { value: 'gold', label: 'Gold' },
        { value: 'blue', label: 'Blue' },
        { value: 'silver', label: 'Silver' },
        { value: 'black', label: 'Black' },
    ]

    const shapeOptions = [
        { value: 'rect', label: 'Rectangle' },
        { value: 'pill', label: 'Pill' },
    ]

    const sizeOptions = [
        { value: 'small', label: 'Small' },
        { value: 'medium', label: 'Medium' },
        { value: 'large', label: 'Large' },
        { value: 'responsive', label: 'Responsive' },
    ]

    const labelOptions = [
        { value: 'checkout', label: 'Checkout' },
        { value: 'credit', label: 'Credit' },
        { value: 'pay', label: 'Pay' },
        { value: 'buynow', label: 'Buy Now' },
        { value: 'paypal', label: 'Paypal' },
    ]

    let selectedColorOption = colorOptions.filter( opt => { 
        if ( 'undefined' != typeof wp_travel_express_checkout ) { 
            return opt.value == wp_travel_express_checkout.color 
        }
    } )
    let selectedShapeOption = shapeOptions.filter( opt => { 
        if ( 'undefined' != typeof wp_travel_express_checkout ) { 
            return opt.value == wp_travel_express_checkout.shape
        }
    } )
    let selectedSizeOption = sizeOptions.filter( opt => {
        if ( 'undefined' != typeof wp_travel_express_checkout ) {
            return opt.value == wp_travel_express_checkout.size
        }
    } )
    let selectedLabelOption = labelOptions.filter( opt => { 
        if ( 'undefined' != typeof wp_travel_express_checkout ) {
            return opt.value == wp_travel_express_checkout.label
        }
    } )

    return (
        <>
            {
                wt_test_mode === 'yes' ?
                <strong><p className="howTo" style={{color: '#ffffff', textAlign: 'center', backgroundColor: 'darkseagreen'}} >{ __( 'Test Mode Active', 'wp-travel-pro' ) }</p></strong>
                : <strong><p className="howTo" style={{color: '#ffffff', textAlign: 'center', backgroundColor: 'darkseagreen'}} >{ __( 'Live Mode Active', 'wp-travel-pro' ) }</p></strong>
            }
            <PanelRow>
                <label>{ _wp_travel.setting_strings.payment.enable_paypal_express_checkout }</label>
                <div className="wp-travel-field-value">
                    <ToggleControl
                        checked={ payment_option_express_checkout == 'yes' }
                        onChange={ () => {
                            updateSettings({
                                ...allData,
                                payment_option_express_checkout: 'yes' == payment_option_express_checkout ? 'no': 'yes'
                            })
                        } }
                    />
                    <p className="description">{_wp_travel.setting_strings.payment.enable_paypal_express_checkout_note}</p>
                </div>
            </PanelRow>

            {
                payment_option_express_checkout === 'yes' && wt_test_mode === 'yes' &&

                <PanelRow>
                    <label>{ _wp_travel.setting_strings.payment.sandbox_client_id }</label>
                        <div className="wp-travel-field-value">
                            <TextControl
                                value={ 'undefined' != typeof wp_travel_express_checkout_sand_box ? wp_travel_express_checkout_sand_box.client_id : ''}
                                onChange={
                                    (value) => { updatePaypalExpressData('wp_travel_express_checkout_sand_box', 'client_id', value) }
                                }
                            />
                            {/* <p className="description">{__('e.g. AQwT-8eC6_uJa0-m0Wg8YpC0vjNW_qU1eHhI...', 'wp-travel-pro')}</p> */}
                            <p className="description" dangerouslySetInnerHTML={{ __html: clientIdDesc }}></p>
                        </div>
                </PanelRow>
            }
            {
                payment_option_express_checkout === 'yes' && wt_test_mode === 'no' &&
                <PanelRow>
                    <label>{ _wp_travel.setting_strings.payment.production_client_id }</label>
                        <div className="wp-travel-field-value">
                            <TextControl
                                value={ 'undefined' != typeof wp_travel_express_checkout_production ? wp_travel_express_checkout_production.client_id : ''}
                                onChange={
                                    (value) => { updatePaypalExpressData('wp_travel_express_checkout_production', 'client_id', value) }
                                }
                            />
                            <p className="description">{__('e.g. AQwT-8eC6_uJa0-m0Wg8YpC0vjNW_qU1eHhI...', 'wp-travel-pro')}</p>
                            <p className="description" dangerouslySetInnerHTML={{ __html: clientIdDesc }}></p>
                        </div>
                </PanelRow>
            }
            {
                payment_option_express_checkout === 'yes' &&

                <>
                <PanelRow>
                    <strong><label>{_wp_travel.setting_strings.payment.paypal_express_checkout_advance_options}</label></strong>
                </PanelRow>

                <PanelRow>
                    <label>{ _wp_travel.setting_strings.payment.paypal_express_checkout_advance_color }</label>
                    <div className="wp-travel-field-value">
                        <Select
                            options = {colorOptions}
                            value={ 'undefined' != typeof selectedColorOption[0] && 'undefined' != typeof selectedColorOption[0].label ? selectedColorOption[0] : [] }
                            onChange={(data) => {
                                if ('' !== data) {
                                    updatePaypalExpressData( 'wp_travel_express_checkout', 'color', data.value );
                                }
                            }}
                            className='wp-travel-paypal-express-checkout-color-option'
                        />
                    </div>

                    <label>{ _wp_travel.setting_strings.payment.paypal_express_checkout_advance_shape }</label>
                    <div className="wp-travel-field-value">
                        <Select
                            options = {shapeOptions}
                            value={ 'undefined' != typeof selectedShapeOption[0] && 'undefined' != typeof selectedShapeOption[0].label ? selectedShapeOption[0] : [] }
                            onChange={(data) => {
                                if ('' !== data) {
                                    updatePaypalExpressData( 'wp_travel_express_checkout', 'shape', data.value );
                                }
                            }}
                            className='wp-travel-paypal-express-checkout-color-option'
                        />
                    </div>
                </PanelRow>

                <PanelRow>
                    <label>{ _wp_travel.setting_strings.payment.paypal_express_checkout_advance_size }</label>
                    <div className="wp-travel-field-value">
                        
                        <Select
                            options = {sizeOptions}
                            value={ 'undefined' != typeof selectedSizeOption[0] && 'undefined' != typeof selectedSizeOption[0].label ? selectedSizeOption[0] : [] }
                            onChange={(data) => {
                                if ('' !== data) {
                                    updatePaypalExpressData( 'wp_travel_express_checkout', 'size', data.value );
                                }
                            }}
                            className='wp-travel-paypal-express-checkout-color-option'
                        />
                    </div>

                    <label>{ _wp_travel.setting_strings.payment.paypal_express_checkout_advance_label }</label>
                    <div className="wp-travel-field-value">
                        <Select
                            options = {labelOptions}
                            value={ 'undefined' != typeof selectedLabelOption[0] && 'undefined' != typeof selectedLabelOption[0].label ? selectedLabelOption[0] : [] }
                            onChange={(data) => {
                                if ('' !== data) {
                                    updatePaypalExpressData( 'wp_travel_express_checkout', 'label', data.value );
                                }
                            }}
                            className='wp-travel-paypal-express-checkout-color-option'
                        />
                    </div>
                </PanelRow>

                {
                    'undefined' != typeof wp_travel_express_checkout &&
                    <PanelRow>
                        <label>{ _wp_travel.setting_strings.payment.paypal_express_checkout_allow_payments_using_cards }</label>
                        <div className="wp-travel-field-value">
                            <ToggleControl 
                                checked = { wp_travel_express_checkout.allow_card === 'on' }
                                onChange={ () => {
                                    updatePaypalExpressData( 'wp_travel_express_checkout', 'allow_card', 'on' == wp_travel_express_checkout.allow_card ? 'off': 'on' );
                                } }
                            />
                        </div>  
                    </PanelRow>
                }
                </>
            }
        </>
    )
}